import { useMemo } from 'react';
import { useCanAccess } from 'react-admin';
import { resources } from '@repo/c360-ra-components';

export const useDashboardAccess = () => {
  const c1 = useCanAccess({ resource: resources.clientUsers, action: 'list' });
  const c2 = useCanAccess({ resource: resources.guardianCustomers, action: 'list' });
  const c3 = useCanAccess({ resource: resources.blacklistRecords, action: 'list' });
  const c4 = useCanAccess({ resource: resources.signinAttemptHistoryLogs, action: 'list' });
  const c5 = useCanAccess({ resource: resources.signupAttemptHistoryLogs, action: 'list' });
  const c6 = useCanAccess({ resource: resources.maxSignupRecords, action: 'list' });
  const c7 = useCanAccess({ resource: resources.recurringPayments, action: 'list' });
  const c8 = useCanAccess({ resource: resources.paymentCards, action: 'list' });
  const c9 = useCanAccess({ resource: resources.recurringPaymentsExecutionLogs, action: 'list' });
  const c10 = useCanAccess({ resource: resources.taReports, action: 'list' });
  const c11 = useCanAccess({ resource: resources.orderRecords, action: 'list' });
  const c12 = useCanAccess({ resource: resources.nonOnlineRenewals, action: 'list' });
  const c13 = useCanAccess({ resource: resources.customerApplications, action: 'list' });
  const c14 = useCanAccess({ resource: resources.applicants, action: 'list' });
  const c15 = useCanAccess({ resource: resources.riskProfiles, action: 'list' });
  const c16 = useCanAccess({ resource: resources.documents, action: 'list' });
  const c17 = useCanAccess({ resource: resources.docusign, action: 'list' });
  const c18 = useCanAccess({ resource: resources.adminUsers, action: 'list' });
  const c19 = useCanAccess({ resource: resources.roles, action: 'list' });
  const c20 = useCanAccess({ resource: resources.policies, action: 'list' });
  const c21 = useCanAccess({ resource: resources.auditLogs, action: 'list' });
  const c22 = useCanAccess({ resource: resources.troubleshootingGuidelines, action: 'list' });
  const c23 = useCanAccess({ resource: resources.salespalApplications, action: 'list' });
  const c24 = useCanAccess({ resource: resources.manualMerges, action: 'list' });
  const c25 = useCanAccess({ resource: resources.manualPaymentExecutionLogs, action: 'list' });
  const c26 = useCanAccess({ resource: resources.facRecords, action: 'list' });
  const c27 = useCanAccess({ resource: resources.bankCards, action: 'list' });
  const c28 = useCanAccess({ resource: resources.onfidoVerifications, action: 'list' });

  const accessMap = useMemo(
    () => ({
      [resources.clientUsers]: c1.canAccess,
      [resources.guardianCustomers]: c2.canAccess,
      [resources.blacklistRecords]: c3.canAccess,
      [resources.signinAttemptHistoryLogs]: c4.canAccess,
      [resources.signupAttemptHistoryLogs]: c5.canAccess,
      [resources.maxSignupRecords]: c6.canAccess,
      [resources.recurringPayments]: c7.canAccess,
      [resources.paymentCards]: c8.canAccess,
      [resources.recurringPaymentsExecutionLogs]: c9.canAccess,
      [resources.taReports]: c10.canAccess,
      [resources.orderRecords]: c11.canAccess,
      [resources.nonOnlineRenewals]: c12.canAccess,
      [resources.customerApplications]: c13.canAccess,
      [resources.applicants]: c14.canAccess,
      [resources.riskProfiles]: c15.canAccess,
      [resources.documents]: c16.canAccess,
      [resources.docusign]: c17.canAccess,
      [resources.adminUsers]: c18.canAccess,
      [resources.roles]: c19.canAccess,
      [resources.policies]: c20.canAccess,
      [resources.auditLogs]: c21.canAccess,
      [resources.troubleshootingGuidelines]: c22.canAccess,
      [resources.salespalApplications]: c23.canAccess,
      [resources.manualMerges]: c24.canAccess,
      [resources.manualPaymentExecutionLogs]: c25.canAccess,
      [resources.facRecords]: c26.canAccess,
      [resources.bankCards]: c27.canAccess,
      [resources.onfidoVerifications]: c28.canAccess,
    }),
    [
      c1.canAccess,
      c2.canAccess,
      c3.canAccess,
      c4.canAccess,
      c5.canAccess,
      c6.canAccess,
      c7.canAccess,
      c8.canAccess,
      c9.canAccess,
      c10.canAccess,
      c11.canAccess,
      c12.canAccess,
      c13.canAccess,
      c14.canAccess,
      c15.canAccess,
      c16.canAccess,
      c17.canAccess,
      c18.canAccess,
      c19.canAccess,
      c20.canAccess,
      c21.canAccess,
      c22.canAccess,
      c23.canAccess,
      c24.canAccess,
      c25.canAccess,
      c26.canAccess,
      c27.canAccess,
      c28.canAccess,
    ],
  );

  const isAccessPending =
    c1.isPending ||
    c2.isPending ||
    c3.isPending ||
    c4.isPending ||
    c5.isPending ||
    c6.isPending ||
    c7.isPending ||
    c8.isPending ||
    c9.isPending ||
    c10.isPending ||
    c11.isPending ||
    c12.isPending ||
    c13.isPending ||
    c14.isPending ||
    c15.isPending ||
    c16.isPending ||
    c17.isPending ||
    c18.isPending ||
    c19.isPending ||
    c20.isPending ||
    c21.isPending ||
    c22.isPending ||
    c23.isPending ||
    c24.isPending ||
    c25.isPending ||
    c26.isPending ||
    c27.isPending ||
    c28.isPending;

  return { accessMap, isAccessPending };
};
